import { MenuItemType } from '@/layouts/private/topBar/components/sideBarMenu/model/SideBarMenuItems.model.tsx';

export type MenuTranslation = Record<MenuItemType, string>;

export const menuTranslation: MenuTranslation = {
  analysisRemarks: 'Analysis Remarks',
  cvSearch: 'CV Search',
  experienceCompanies: 'Experience Companies',
  intakeCallTemplates: 'Intake Call Library',
  interviewSimulation: 'Interview Simulation',
  meetings: 'Meetings',
  processes: 'Processes',
  processTemplates: 'Process Templates',
  statistics: 'Statistics',
  tags: 'Keywords',
};
